
import { defineComponent, ref, watch, onMounted } from 'vue';

export default defineComponent({
  props: {
    keyValue: {
      type: String,
      required: false
    },
    label: {
      type: String,
      required: true
    },
    required:{
      type: Boolean,
      required: false,
    },
    value: {
      type: String,
      required: false,
      default: ''  // Menyediakan nilai default jika tidak ada value
    },
    options: {
      type: Array,
      required: false,
      default: () => []  // Menyediakan array kosong sebagai default
    }
  },
  setup(props, { emit }) {
    const inputValue = ref(props.value);

    // Watch props.value to reactively update inputValue
    watch(() => props.value, (newValue) => {
      inputValue.value = newValue;
    });

    // Initialize inputValue when the component is first mounted
    onMounted(() => {
      inputValue.value = props.value;
    });

    const updateValue = () => {
      emit('update', { key:  props.keyValue || props.label, value: inputValue.value });
    };

    return {
      inputValue,
      updateValue
    };
  }
});
